module.exports = __webpack_public_path__ + "img/icon-Valor-Selecionado.760e4093.svg";